import { useTranslation } from 'next-i18next';

import { JobApplicationStatusKey } from '@restworld/utility-types';

import {
  KANBAN_HIRED_STATUS_KEYS,
  KANBAN_INTERESTED_STATUS_KEYS,
  KANBAN_INTERVIEW_STATUS_KEYS,
  KANBAN_STAGE_STATUS_KEYS,
} from '../candidate-visibility';

export type KanbanRow = {
  title: string;
  matchStatusKey: JobApplicationStatusKey[];
  showCount?: boolean;
  id: 'interested' | 'interview' | 'stage' | 'hired' | 'discarded';
  icon?: 'DevicePhoneMobileIcon' | 'UserGroupIcon' | 'ClipboardCheckIcon';
};

export function useKanbanRowsAndMatchStatusKeys() {
  const { t } = useTranslation('job-positions-page');

  const kanbanRows: KanbanRow[] = [
    {
      title: t('to_be_called'),
      matchStatusKey: KANBAN_INTERESTED_STATUS_KEYS,
      id: 'interested' as const,
      icon: 'DevicePhoneMobileIcon' as const,
    },
    {
      title: t('to_be_interviewed'),
      matchStatusKey: KANBAN_INTERVIEW_STATUS_KEYS,
      id: 'interview' as const,
      icon: 'UserGroupIcon' as const,
    },
    {
      title: t('negotiation'),
      matchStatusKey: KANBAN_STAGE_STATUS_KEYS,
      id: 'stage' as const,
      icon: 'ClipboardCheckIcon' as const,
    },
    {
      title: t('to_be_hired'),
      matchStatusKey: KANBAN_HIRED_STATUS_KEYS,
      id: 'hired' as const,
    },
    // {
    //   title: t('to_be_rejected'),
    //   matchStatusKey: ['worker_jp_discarded'],
    //   showCount: true,
    //   id: 'discarded' as const,
    // },
  ];
  return kanbanRows;
}
